import { useMutation, useQuery } from '@apollo/client';
import { Button, IconMail, useToast } from 'braid-design-system';
import React from 'react';

import {
  GetBuyerEmailAddressDocument,
  ResetPasswordDocument,
} from 'src/generated/graphql';

const ResetPasswordButton = () => {
  const showToast = useToast();
  const { data } = useQuery(GetBuyerEmailAddressDocument);
  const [resetPassword, resetPasswordResult] = useMutation(
    ResetPasswordDocument,
    {
      variables: { email: data?.buyer?.emailAddress ?? '' },
    },
  );

  const onButtonClick = async () => {
    try {
      await resetPassword();
      showToast({
        tone: 'neutral',
        icon: <IconMail />,
        message: 'Email sent!',
        description: `We've sent instructions on how to reset your password to ${data?.buyer?.emailAddress}`,
        data: { testid: 'reset-password-success-toast' },
      });
    } catch {
      showToast({
        tone: 'critical',
        message: 'Reset password error',
        description:
          'Something went wrong while requesting reset for your password. Please try again.',
        data: { testid: 'reset-password-error-toast' },
      });
    }
  };

  return (
    <Button
      id="reset-password-button"
      icon={<IconMail />}
      variant="soft"
      loading={resetPasswordResult.loading}
      onClick={onButtonClick}
    >
      Request password reset
    </Button>
  );
};
export default ResetPasswordButton;
